import Button from "../../component/button/Button";
import { seasonListApi } from "../../api/HttpApis";
import { RxImage } from "react-icons/rx";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import { useState } from "react";
import { CiImageOn } from "react-icons/ci";

const MediaImage = ({ src, alt }) => {
  const [hasError, setHasError] = useState(false);
  if (hasError || !src) return <CiImageOn size={40} />;
  return (
    <img
      className="imageBox"
      src={src}
      alt={alt || "Media"}
      width={40}
      height={30}
      onError={() => setHasError(true)}
    />
  );
};

export const SeasonData = async (
  seriesId,
  selectedDate,
  selectedCreator,
  selectedRating,
  selectedGenre,
  page,
  perpage
) => {
  if (!seriesId) return [];
  const response = await seasonListApi(
    seriesId,
    {},
    selectedDate,
    selectedCreator,
    selectedRating,
    selectedGenre,
    "",
    perpage,
    page
  );
  const dataArray = Array.isArray(response?.data?.data)
    ? response.data.data
    : [];

  return dataArray.map((item) => ({
    season_number: item.season_number,
    name: trimStr(item.name),
    media: item.portrait,
    status: item.status,
    qc_status: item.qc_status,
    rating: item.rating,
    portrait_url: item.portrait,
    landscape_url: item.landscape,
    access: item.access,
    buttonText: "Edit",
    buttonText2: "Remove",
    buttonText3: "Episodes",
    seasonId: item.season_id,
    seriesId: seriesId,
    totalCount: response?.data?.total,
  }));
};

export const Columns = (
  navigate,
  handleEdit,
  handleDelete,
  deletingId,
  editingId,
  episodeLoaderId,
  setEpisodeLoaderId,
  setSearchQuery
) => {
  const handleEpisodeClick = (seasonId, seriesId) => {
    localStorage.setItem("seriesId", seriesId);
    localStorage.setItem("seasonId", seasonId);
    setSearchQuery(null)
    setEpisodeLoaderId(seasonId);
    setTimeout(() => {
      navigate(`/mainlayout/series/${seriesId}/seasons/${seasonId}/episodes`);
    }, 300);
  };

  return [
    {
      key: "name",
      label: "Name",
      render: (item) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            display: "block",
            minWidth: 0,
          }}
        >
          {trimStr(item.name, 15)}
        </div>
      ),
    },
    {
      key: "media",
      label: "Media",
      render: (item) => <MediaImage src={item.media} alt={item.name} />,  // ← only this changed
    },
    { key: "status", label: "Status" },
    // { key: "season_number", label: "Season Number" },
    { key: "rating", label: "Rating" },
    { key: "access", label: "Access" },
    {
      key: "edit",
      render: (item) => (
        <div style={{ display: "flex", gap: "20px" }}>
          <Button
            onClick={() => handleEdit(item)}
            loading={editingId === item.id}
          >
            {item.buttonText}
          </Button>
          <Button
            onClick={() => handleDelete(item)}
            loading={deletingId === item.seasonId}
            disabled={deletingId === item.seasonId}
          >
            {deletingId === item.seasonId ? "Deleting..." : item.buttonText2}
          </Button>
          <Button
            onClick={() => handleEpisodeClick(item.seasonId, item.seriesId)}
            loading={episodeLoaderId === item.seasonId}
            // style={{ width: "145%", fontSize: "16px" }}
          >
            {episodeLoaderId === item.seasonId
              ? "Loading..."
              : item.buttonText3}
          </Button>
        </div>
      ),
    },
    // {
    //   key: "delete",
    //   render: (item) => (

    //   ),
    // },

    // {
    //   key: "episodes",
    //   render: (item) => (

    //   ),
    // },
  ];
};